import React from 'react';
import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

const StyledMarquee = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: #ffbf00;
  padding: 10px 0;
`;

const ScrollContent = styled.div`
  display: inline-block;
  white-space: nowrap;
  animation: ${scroll} 15s linear infinite;
  font-size: 16px;
  font-weight: normal;
  color: #000;
`;

const ScrollMessage = ({ scrollMessage }) => {
  if (!scrollMessage) return null;

  return (
    <StyledMarquee>
      <ScrollContent>{scrollMessage}</ScrollContent>
    </StyledMarquee>
  );
};

export default ScrollMessage;
